import $ from 'jquery';
import toastr from 'toastr';
import { I18n } from "i18n-js";
const i18n = new I18n();

import { schoolOverviewSetup } from './overview';
import { datepickerChange } from './overview';

$(document).ready(function() {

  var $seeReports = $('#seeReports');
  var $selectPartner = $('.select-partner-report-js');
  var $selectSecretaries = $('.select-secretaries-report-js');
  var $selectYears = $('.select-year-report-js');

  $seeReports.click(function() {
    var partnerId = $('.select-partner-report-js option:selected').val();
    var secretaryId = $('.select-secretaries-report-js option:selected').val();
    var year = $('.select-year-report-js option:selected').val();

    if (partnerId == "" || secretaryId == "" || year == "") {
      toastr.warning(i18n.t('views.configs.school_year.warning.must_select_partner'))
      return;
    }

    $selectPartner.prop('disabled', true);
    $selectSecretaries.prop('disabled', true);
    $selectYears.prop('disabled', true);

    $.ajax({
      url: './reports',
      data: {
        partner_id: partnerId,
        secretary_id: secretaryId,
        year: year
      },
      success: function(res) {
        $('#reportContent').html(res);
        schoolOverviewSetup();
        $('.input-group.date.overview-picker').datepicker({
          language: "pt-BR",
          clearBtn: true
        }).on('clearDate', datepickerChange);
      },
      error: function(data) {
        toastr.error(data.responseJSON.message);
      }
    });
  });
});
